import { RequiredIndicatorPlacement as Placement, RequiredIndicator } from '@wix/ambassador-forms-v4-form-http/types';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from '../../sdk/components';
import { ImageAlignment, ImageFit, ImagePosition } from '../../types/image';
import { ImageComponentWUT } from '../image-choice-field/image-component-wut';
import { classes } from './field-label-wut.st.css';
const DEFAULT_IMAGE_ASPECT_RATIO = 3 / 2;
export const FieldLabelWUT = ({ labelId, htmlFor, label, required = false, hideLabel = false, requiredIndicatorHidden = false, requiredIndicatorType = RequiredIndicator.ASTERISK, requiredIndicatorPlacement = Placement.AFTER_FIELD_TITLE, media, mediaSettings })=>{
    const Tag = htmlFor ? 'label' : 'div';
    const { t } = useTranslation();
    const { imagePosition = ImagePosition.TOP, imageFit = ImageFit.COVER, imageAlignment = ImageAlignment.CENTER } = media ? mediaSettings ?? {} : {};
    const labelAfterRequiredIndicator = requiredIndicatorType === RequiredIndicator.ASTERISK && requiredIndicatorPlacement === Placement.BEFORE_FIELD_TITLE;
    const imageElement = media ? /*#__PURE__*/ React.createElement("div", {
        className: classes.imageContainer
    }, /*#__PURE__*/ React.createElement(ImageComponentWUT, {
        image: media,
        alt: media.altText,
        aspectRatio: DEFAULT_IMAGE_ASPECT_RATIO,
        imageAlignment: imageAlignment,
        imageResize: imageFit
    })) : null;
    const labelElement = /*#__PURE__*/ React.createElement(Tag, {
        id: labelId,
        htmlFor: htmlFor,
        className: classNames(classes.label, {
            [classes.labelWithImage]: media,
            [classes.hidden]: hideLabel
        })
    }, !labelAfterRequiredIndicator && label, required && !requiredIndicatorHidden && /*#__PURE__*/ React.createElement(React.Fragment, null, requiredIndicatorType === RequiredIndicator.ASTERISK && /*#__PURE__*/ React.createElement("span", {
        "aria-hidden": "true",
        className: labelAfterRequiredIndicator ? classes.indicatorBeforeLabel : classes.indicatorAfterLabel
    }, "*"), requiredIndicatorType === RequiredIndicator.TEXT && /*#__PURE__*/ React.createElement("span", {
        "aria-hidden": "true",
        className: classes.indicatorAfterLabel
    }, t('settings.required-indicator-text'))), labelAfterRequiredIndicator && label);
    if (!media) {
        return labelElement;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classes.labelWithImageContainer
    }, imagePosition === ImagePosition.TOP ? imageElement : null, labelElement, imagePosition === ImagePosition.BOTTOM ? imageElement : null);
};

//# sourceMappingURL=field-label-wut.js.map